<template>
  <div>
    <a-row :gutter="30">
      <a-col :xs="24" :sm="16" class="ratio">
        <div
          class="banner"
          :style="{ background: 'url(/resources/images/banner.png) ' }"
        ></div>
      </a-col>
      <a-col :xs="24" :sm="8" class="ratio">
        <div class="card">
          <div class="card-body">
            <div class="utils__title mb-3">
              <strong class="text-uppercase font-size-16">{{
                $t("dashboard.announcement")
              }}</strong>
            </div>
            <p>{{ $t("dashboard.announcement1") }}</p>
          </div>
        </div>
      </a-col>
    </a-row>
    <!-- Messeger -->
    <div
      class="fb-customerchat"
      attribution="setup_tool"
      page_id="107960830767730"
      logged_in_greeting="Chào bạn, Fanpage GoGame có thể hỗ trợ gì cho bạn?"
      logged_out_greeting="Chào bạn, Fanpage GoGame có thể hỗ trợ gì cho bạn?"
    ></div>
    <!--  -->
  </div>
</template>
<script>
import user from "@/mixins/user";
export default {
  data() {
    return {};
  },
  mounted() {
    console.log(this.$i18n.locale, "Language");
  },
  mixins: [user]
};
// Messeger
window.fbAsyncInit = function() {
  FB.init({
    xfbml: true,
    version: "v6.0"
  });
};
(function(d, s, id) {
  var js,
    fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) return;
  js = d.createElement(s);
  js.id = id;
  js.src = "https://connect.facebook.net/vi_VN/sdk/xfbml.customerchat.js";
  fjs.parentNode.insertBefore(js, fjs);
})(document, "script", "facebook-jssdk");
</script>
<style scoped>
.list-video {
  width: 100%;
  max-width: 500px;
}
.video-container {
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 30px;
  height: 0;
  overflow: hidden;
  margin-bottom: 20px;
}

.video-container iframe,
.video-container object,
.video-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.banner {
  padding-top: 25%;
  background-repeat: no-repeat !important;
  background-size: contain !important;
  border-radius: 8px;
  background-position: center !important;
}
.ratio {
  padding-top: 25%;
  position: relative;
  margin-bottom: 20px;
}
.ratio.small {
  padding-top: 17%;
}
.ratio > div,
.ratio iframe {
  position: absolute;
  top: 0;
  width: 95%;
  height: 100%;
}
/*.ratio iframe {
  width: 100%;
  height: 100%
}*/
</style>
